import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BinsService {

  constructor(private http: HttpClient) { }

  getBinsList() {
    return this.http.get<any>(`${environment.inventoryURl}BinSection`);
  }

  checkAssociatedBin(id) {
    return this.http.get<any>(`${environment.inventoryURl}BinSection/CheckBinProductExist?binSectionId=${id}`);
  }

  deleteBin(id) {
    return this.http.delete<any>(`${environment.inventoryURl}BinSection/${id}`)
      .toPromise()
      .then(res => res);
  }

  getAllGroupTypes(groupId) {
    return this.http.get<any>(`${environment.inventoryURl}Type?groupId=${groupId}`);
  }

  addBin(data) {
    return this.http.post<any>(`${environment.inventoryURl}BinSection`, data)
      .toPromise()
      .then(res => res);
  }

  updateBin(data) {
    return this.http.put<any>(`${environment.inventoryURl}BinSection`, data)
      .toPromise()
  }
}
